module.exports = __webpack_public_path__ + "static/media/24hours.909cf6af.png";